import {ContainerClusterEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useNavigate} from "react-router-dom";
import {ContainerClusterAction} from "./ContainerClusterActionMenu";
import {useContainerClusterMutation} from "../../../hooks/useContainerClusterMutation";

export type UseContainerClusterActionProps = {}

export type UseContainerClusterActionResult = {
  onContainerClusterActionClick: (containerCluster: ContainerClusterEntity, action: ContainerClusterAction) => void;
}

export const useContainerClusterAction = (props: UseContainerClusterActionProps = {}): UseContainerClusterActionResult => {
  const {} = props

  const navigate = useNavigate();

  const {
    deleteContainerCluster,
  } = useContainerClusterMutation()

  const _onContainerClusterActionClick = useCallback((containerCluster: ContainerClusterEntity, action: ContainerClusterAction) => {
    if (action === "EDIT") {
      navigate(`/container-clusters/form`, {state: {id: containerCluster.id}})
    } else if (action === "DELETE") {
      deleteContainerCluster(containerCluster.id, () => navigate(-1))
    }
  }, [navigate, deleteContainerCluster])

  return {
    onContainerClusterActionClick: _onContainerClusterActionClick
  }
}
